import { useCookies } from "react-cookie";
import { useQuery } from "@tanstack/react-query";
import { getUserFn } from "../components/APIServices/Services";
import { useStateContext } from "../components/context/index";
import Spinner from "../components/ui/Spinner";
import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

const AuthMiddleware = ({ children }) => {
  const [cookies] = useCookies("logged_in");
  const StateContext = useStateContext();

  const query = useQuery(["authUser"], () => getUserFn(), {
    enabled: !!cookies.logged_in,
    select: (data) => data.data.user,
    onSuccess: (data) => {
      StateContext.dispatch({ type: "SET_AUTH_USER", payload: data });
    },
  });

  if (query.isLoading && cookies.logged_in) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Spinner />
        </Container>
      </Box>
    )
  }

  return children;
};

export default AuthMiddleware;
